import React, { Component } from 'react';
import {sendEmail} from "../../ApiSeervice";

class FormContact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            phone: '',
            email: '',
            subject: '',
            message: ''
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        // console.log(e);
    }

    handleSubmit = (e) => {
        e.preventDefault(); // Sayfa yenilenmesini engeller

        // Tüm form verilerini konsola yazdır
        console.log("Form verileri:", this.state);
        let req={
            name: this.state.name,
            phone: this.state.phone,
            email: this.state.email,
            subject: this.state.subject,
            message: this.state.message
        }

        console.log( req);
        sendEmail(req)
    }

    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-headings style-2 clearfix">
                    <h2 className="heading">Bize Ulaşın</h2>
                    <div className="sep has-width w80 accent-bg clearfix" />
                    <p className="sub-heading">Hizmetlerimiz hakkında daha fazla bilgi için lütfen bizimle iletişime geçin.</p>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={36} data-mobile={35} data-smobile={35} />
                <div className="themesflat-contact-form style-2 clearfix">
                    <form onSubmit={this.handleSubmit} className="form-submit contact-form wpcf7-form">
                        <span className="wpcf7-form-control-wrap your-name">
                            <input type="text" tabIndex={1} id="name" name="name" value={this.state.name}
                                onChange={this.handleChange}
                                className="wpcf7-form-control" placeholder="İsim" required />
                        </span>
                        <span className="wpcf7-form-control-wrap your-phone">
                            <input type="text" tabIndex={2} id="phone" name="phone" value={this.state.phone}
                                onChange={this.handleChange}
                                className="wpcf7-form-control" placeholder="Telefon" />
                        </span>
                        <span className="wpcf7-form-control-wrap your-email">
                            <input type="email" tabIndex={3} id="email" name="email" value={this.state.email}
                                onChange={this.handleChange}
                                className="wpcf7-form-control" placeholder="Email" required />
                        </span>
                        <span className="wpcf7-form-control-wrap your-subject">
                            <input type="text" tabIndex={4} id="subject" name="subject" value={this.state.subject}
                                onChange={this.handleChange}
                                className="wpcf7-form-control" placeholder="Konu" />
                        </span>
                        <span className="wpcf7-form-control-wrap your-message">
                            <textarea name="message" tabIndex={5} cols={40} rows={10}
                                value={this.state.message}
                                onChange={this.handleChange}
                                className="wpcf7-form-control wpcf7-textarea" placeholder="Mesajınız" required />
                        </span>
                        <span className="wrap-submit">
                            <input type="submit" value="GÖNDER" className="submit wpcf7-form-control wpcf7-submit" id="submit" name="submit" />
                        </span>
                    </form>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={80} data-mobile={60} data-smobile={60} />
            </div>
        );
    }
}

export default FormContact;
